import { render, staticRenderFns } from "./QueryColumnsForm.vue?vue&type=template&id=f6a6c56e&scoped=true&"
import script from "./QueryColumnsForm.vue?vue&type=script&lang=js&"
export * from "./QueryColumnsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a6c56e",
  null
  
)

export default component.exports